import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const BrandVideoBox = () => {
    return (
        <div className="brand-video-box-wrapper">
            <div className="container position-relative">
                <div className="row">
                    <div className="col-12 order-2 order-lg-1">
                        <div className="text-box">
                            <h2 className="title">لورم ایپسوم</h2>
                            <p className="text">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده
                                از
                                طراحان
                                گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای
                                شرایط
                                فعلی
                                تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد، کتابهای
                                زیادی
                                در
                                شصت و
                                سه درصد گذشته حال و آینده</p>
                        </div>
                    </div>
                    <div className="col-12 order-1 order-lg-2">
                        <div className="video-box position-absolute movie-screen-box">
                            <video poster="./assets/sample-image/s1-640x360.png" className="screen-video">
                                <source src="./assets/video/video1.mp4" type="video/mp4"/>
                            </video>
                            <IconName name="play" className="icon play-icon video-play-button"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandVideoBox;
